import Lozenge from "@atlaskit/lozenge";

import RDMJLogo from "../assets/SupportCenterLogos/RDMJ.svg";
import RCCMJLogo from "../assets/SupportCenterLogos/RCCMJ.svg";
import RADMJLogo from "../assets/SupportCenterLogos/RADMJ.svg";
import LicenseLogo from "../assets/SupportCenterLogos/Licensing.svg";
import LegalSecurityLogo from "../assets/SupportCenterLogos/LegalSecurity.svg";
import FAQLogo from "../assets/SupportCenterLogos/FAQ.svg";
import ReleaseNotesLogo from "../assets/SupportCenterLogos/ReleaseNotes.svg";
import GetStartedLogo from "../assets/SupportCenterLogos/GetStarted.svg";

export const pageSize = 50;

export const objectTypetoLevelMapping = {
  root: 1,
  projectType: 2,
  managedBy: 3,
  projectNames: 5,
  teamLead: 7,
  schemes: 7,
  schemeChild1: 9,
  schemeChild2: 11,
};

export const mapDirectionTextMapper = (mapDirection) => {
  switch (mapDirection) {
    case "UD":
      return "RL";
    case "RL":
      return "DU";
    case "DU":
      return "LR";
    case "LR":
      return "UD";
    default:
      return "UD";
  }
};

export const getNodeAndEdgeColor = (objectType) => {
  switch (objectType) {
    case "project":
      return "#FF5630";
    case "permissionScheme":
      return "#6554C0";
    case "permissionSpermissionschemecheme":
      return "#6554C0";
    case "workflowScheme":
      return "#FFAB00";
    case "workflowscheme":
      return "#FFAB00";
    case "workflows":
      return "#FFAB00";
    case "issue_types":
      return "#0065FF";
    case "issue_type_scheme":
      return "#0065FF";
    case "issue_type_screen_scheme":
      return "#0065FF";
    case "workflow":
      return "#FFAB00";
    case "permissionType":
      return "#6554C0";
    case "permission":
      return "#6554C0";
    case "screens":
      return "#6554C0";
    case "fields":
      return "#6554C0";
    case "user":
      return "#6554C0";
    case "summarychild":
      return "#0065FF";
    case "defaultRoot":
      return "#FFAB00";
    case "changed":
    case "unChanged":
      return "black";
    default:
      return "#FF5630";
  }
};

export const getNodeLevel = (objectType) => {
  switch (objectType) {
    case "project":
      return 4;
    case "permission_scheme":
      return 4;
    case "field_config":
      return 4;
    case "field_config_scheme":
      return 4;
    case "screen_schemes":
      return 6;
    case "workflow_scheme":
      return 4;
    case "workflows":
      return 6;
    case "issue_types":
      return 8;
    case "issue_type_scheme":
      return 4;
    case "issue_type_screen_scheme":
      return 4;
    case "screens":
      return 8;
    case "fields":
      return 10;
    case "statuses":
      return 8;
    case "changed.Children":
    case "unChanged.Children":
    case "changed.Parents":
    case "unChanged.Parents":
      return 2;
    default:
      return 2;
  }
};

export const rootNodeId = {
  rootSite: "Root",
  project: "project",
  projectjsm: "rootjsm",
  projectjwm: "rootjwm",
  projectjira: "rootjira",
  projectdiscovery: "projectDiscovery",
  workflow: "Workflows",
  permissions: "Permission",
};

export const alwaysPresentNodesForMap = [
  "Root",
  rootNodeId.projectjira,
  rootNodeId.projectjwm,
  rootNodeId.projectjsm,
];

export const alwaysPresentEdgesForMap = [
  {
    from: "Root",
    to: rootNodeId.project,
    smooth: { enabled: true, type: "cubicBezier", roundness: 1 },
    dashes: true,
    color: getNodeAndEdgeColor("defaultRoot"),
    arrows: {
      to: false,
      middle: false,
      from: false,
    },
  },
  {
    from: "Root",
    to: rootNodeId.projectjira,
    smooth: { enabled: true, type: "cubicBezier", roundness: 1 },
    dashes: true,
    color: getNodeAndEdgeColor("defaultRoot"),
    arrows: {
      to: false,
      middle: false,
      from: false,
    },
  },
  {
    from: "Root",
    to: rootNodeId.projectjwm,
    smooth: { enabled: true, type: "cubicBezier", roundness: 1 },
    dashes: true,
    arrows: {
      to: false,
      middle: false,
      from: false,
    },
    color: getNodeAndEdgeColor("defaultRoot"),
  },
  {
    from: "Root",
    to: rootNodeId.projectjsm,
    smooth: { enabled: true, type: "cubicBezier", roundness: 1 },
    dashes: true,
    arrows: {
      to: false,
      middle: false,
      from: false,
    },
    color: getNodeAndEdgeColor("defaultRoot"),
  },
  {
    from: "Root",
    to: rootNodeId.projectdiscovery,
    smooth: { enabled: true, type: "cubicBezier", roundness: 1 },
    dashes: true,
    arrows: {
      to: false,
      middle: false,
      from: false,
    },
    color: getNodeAndEdgeColor("defaultRoot"),
  },
];

export const summaryNodeColorMapping = {
  projects: "#FF5630",
  issues: "#36B37E",
  security: "#6554C0",
  fields: "#DB7093",
  workflowsScreens: "#FFAB00",
  issueAttributesFeatures: "#00B8D9",
};

export const getLocationKey = (location) => {
  switch (location) {
    case "Backup":
      return "Backup";

    case "Restore":
      return "Restore";

    case "Site-insights":
      return "Insights";

    case "Audit-log":
      return "Audit-log";

    case "Settings":
      return "Settings";

    case "Post-install-page":
      return "Support";

    case "Config-page":
      return "Settings";

    case "Project-clone":
      return "Restore";

    case "Cleanup":
      return "Cleanup actions";
    default:
      return "Backup";
  }
};

export const getNodeId = (objectId, objectType) => {
  switch (objectType) {
    case "project":
      return "project" + String(objectId);
    case "permissionScheme":
      return "permissionScheme" + String(objectId);
    case "workflowScheme":
      return "workflowScheme" + String(objectId);
    case "issueType":
      return "issueType" + String(objectId);
    case "issueTypeScheme":
      return "issueTypeScheme" + String(objectId);
    case "screenScheme":
      return "screenScheme" + String(objectId);
    case "issueTypeScreenScheme":
      return "issueTypeScreenScheme" + String(objectId);
    case "workflow":
      return "workflow" + String(objectId);
    case "permissionType":
      return "permissionType" + String(objectId);
    case "permission":
      return "permission" + String(objectId);
    case "user":
      return "user" + String(objectId);
    case "summarychild":
      return "summarychild" + String(objectId);
    default:
      return "unknown" + String(objectId);
  }
};

export const fileSizeTypes = [
  {
    label: "0 B - 500 KB",
    value: { min: 0, max: 512000 },
  },
  {
    label: "500 KB - 5 MB",
    value: { min: 512000, max: 5242880 },
  },
  {
    label: "5 MB - 25 MB",
    value: { min: 5242880, max: 26214400 },
  },
  {
    label: "25 MB - 50 MB",
    value: { min: 26214400, max: 52428800 },
  },
  {
    label: "50 MB - 250 MB",
    value: { min: 52428800, max: 262144000 },
  },
  {
    label: "250 MB - 1 GB",
    value: { min: 262144000, max: 1073741824 },
  },
  {
    label: "1 GB - 2 GB",
    value: { min: 1073741824, max: 2147483648 },
  },
];

export const fieldColumns = [
  "select",
  "is Locked",
  "Field id",
  "Name",
  "Screen count",
  "Context count",
  "Description",
];

export const fieldCartColumns = [
  "Field id",
  "Name",
  "Description",
  "is Locked",
  "Revyz backup exists",
];

export const projectCloneSettingOptions = [
  {
    label: "Create New",
    value: "createNew",
  },
  {
    label: "Reuse existing if it exist, else create new",
    value: "associateExisting",
    isDisabled: true,
  },
];

export const projectCloneSettingOptionsForCrossSite = [
  {
    label: "Create New",
    value: "createNew",
  },
];

//options where both create new and reuse is supported
export const projectCloneSettingOptionsSupportedObjects = [
  {
    label: "Create New",
    value: "createNew",
  },
  {
    label: "Reuse existing if it exist, else create new",
    value: "associateExisting",
  },
];

export const projectCloneCreateNewDisabled = [
  {
    label: "Create New",
    value: "createNew",
    isDisabled: true,
  },
  {
    label: "Reuse existing if it exist, else create new",
    value: "associateExisting",
  },
];

export const settingList = {
  issueType: {
    title: "Issue types",
    description: {
      createNew:
        "Revyz will create issue types associated to the selected project",
      associateExisting:
        "Revyz will reuse the issue types if it exists, else it will create new issue types.",
    },
  },
  issueTypeScheme: {
    title: "Issue type scheme",
    description: {
      createNew:
        "Revyz will create issue type scheme associated to the selected project.",
      associateExisting:
        "Revyz will reuse the issue type scheme if it exists, else it will create new issue type scheme.",
    },
  },
  customFields: {
    title: "Custom fields",
    description: {
      createNew:
        "Revyz will create custom fields associated to the selected project.",
      associateExisting:
        "Revyz will reuse the custom fields if it exists, else it will create new custom fields.",
    },
  },
  screens: {
    title: "Screens",
    description: {
      createNew:
        "Revyz will create screens associated to the selected project.",
      associateExisting:
        "Revyz will reuse the screens if it exists, else it will create new screens.",
    },
  },
  screenSchemes: {
    title: "Screen schemes",
    description: {
      createNew:
        "Revyz will create screen schemes associated to the selected project.",
      associateExisting:
        "Revyz will reuse the screen schemes if it exists, else it will create new screen schemes.",
    },
  },
  issueTypeScreenScheme: {
    title: "Issue type screen scheme",
    description: {
      createNew:
        "Revyz will create issue type screen scheme associated to the selected project.",
      associateExisting:
        "Revyz will reuse the issue type screen schemes if it exists, else it will create new issue type screen scheme.",
    },
  },
  fieldConfiguration: {
    title: "Field configuration",
    description: {
      createNew:
        "Revyz will create field configuration associated to the selected project.",
      associateExisting:
        "Revyz will reuse the field configuration if it exists, else it will create new field configuration.",
    },
  },
  fieldConfigurationScheme: {
    title: "Field configuration scheme",
    description: {
      createNew:
        "Revyz will create field configuration scheme associated to the selected project.",
      associateExisting:
        "Revyz will reuse the field configuration scheme if it exists, else it will create new field configuration scheme.",
    },
  },
  statuses: {
    title: "Statuses",
    description: {
      createNew:
        "Revyz will create statuses associated to the selected project and will map it to the newly created workflows.",
      associateExistingWithoutCreateNew:
        "Revyz will reuse the statuses associated to the reused workflow(s).",
      associateExisting:
        "Revyz will reuse the statuses if it exists, else it will create new statuses.",
    },
  },
  workflows: {
    title: "Workflows",
    description: {
      createNew:
        "Revyz will create workflows associated to the selected project.",
      associateExisting:
        "Revyz will reuse the workflows if it exists, else it will create new workflows.",
    },
  },
  workflowScheme: {
    title: "Workflow scheme",
    description: {
      createNew:
        "Revyz will create workflow scheme associated to the selected project.",
      associateExisting:
        "Revyz will reuse the workflow scheme if it exists, else it will create new workflow scheme.",
    },
  },
  projectRoles: {
    title: "Project roles",
    description: {
      createNew:
        "Revyz will create project roles associated to the selected project.",
      associateExisting:
        "Revyz will reuse the project roles if it exists, else it will create new project roles.",
    },
  },
  permissionScheme: {
    title: "Permission scheme",
    description: {
      createNew:
        "Revyz will create permission scheme associated to the selected project.",
      associateExisting:
        "Revyz will reuse the permission scheme if it exists, else it will create new permission scheme.",
    },
  },
  projectCategory: {
    title: "Project category",
    description: {
      createNew:
        "Revyz will create project category associated to the selected project.",
      associateExisting:
        "Revyz will reuse the project category if it exists, else it will create new project category.",
    },
  },
  filters: {
    title: "Filters",
    description: {
      createNew:
        "Revyz will create filters associated to the selected project.",
      associateExisting:
        "Revyz will reuse the filters if it exists, else it will create new filters.",
    },
  },
};

export const postActions = {
  issueTransition: {
    title: "Issue transition",
    tooltipContent:
      "Due to limitation set by client in Issue transitions, Revyz has insufficient permissions to change the statuses of certain issues which require them to go through a transition. To make sure the statuses of the issues are accurate, client is required to follow the extra steps mentioned in the JQL instruction file below",
    section1:
      "Revyz may not be able to set appropriate status depending on how workflows are configured.",
    section2: `In order to set point-in-time status, you need to execute the JQL required to transition the issues using Jira's bulk update wizard.`,
    downloadText: "Download JQL",
  },
  notificationScheme: {
    title: "Notification scheme",
    tooltipContent:
      "Due to jira limitation, notification scheme could not be restored. To restore the notification scheme associated to the project, refer the csv to create new notification scheme.",
    section1:
      "Revyz was unable to restore the notification scheme due to the jira limitation.",
    section2:
      "In order to create a new notification scheme, you can refer the csv.",
    downloadText: "Download notification scheme",
  },
  issueSecurityScheme: {
    title: "Issue security scheme",
    tooltipContent:
      "Due to jira limitation, issue security scheme could not be restored. To restore the issue security scheme associated to the project, refer the csv to create new issue security scheme.",
    section1:
      "Revyz was unable to restore the issue security scheme due to the jira limitation.",
    section2:
      "In order to create a new issue security scheme, you can refer the csv.",
    downloadText: "Download issue security scheme",
  },
  groups: {
    title: "Groups",
    tooltipContent:
      "Due to jira limitation, groups could not be restored. To restore the groups associated to the project, download the csv to create new groups.",
    section1:
      "Revyz was unable to restore the groups due to the jira limitation.",
    section2: "In order to create a new groups, you can refer the csv.",
    downloadText: "Download groups",
  },
};

export const settingsMapping = {
  0: "Create New",
  1: "Reuse existing if it exist, else create new",
  2: "Reuse exiting",
};

export const tokenExpiryTime = "15 mins";

export const jiraBaseUrlSuffix = ".atlassian.net";

export const urlPrefix = "https://";

export const NodeColorMapping = {
  issues: "black",
  projects: "#0052CC",
  permissions: "#FFAB00",
  permissionType: "#BF2600",
  permissionscheme: "#FF5630",
  issue_types: "#00C7E6",
  issue_type_scheme: "#00C7E6",
  issueTypeScreenScheme: "#00C7E6",
  workflows: "#36B37E",
  workflowscheme: "#36B37E",
  permissionschemeParent: "#FF5630",
  security: "#36B37E",
  parentType: "black",
  screens: "#FFAB00",
  screen_schemes: "#FF5630",
  fields: "#BF2600",
};

// Object Type

// Name

// Parent

// object type

// name

// properties

// desc

// image if any

// children if any

// cleanup actions here
// setSelectedObject({
//   objectType: objectType,
//   objectName: objectName,
//   objectKey:objectKey,
//   objectParentName: objectParentName,
//   objectParentType: objectParentType,
//   objectDesc: objectDesc,
//   objectImage: objectImage,
// });

export const assetsConfigurationType = [
  {
    name: "Create new object schema",
    label: "Object schema",
    value: 1,
  },
  {
    name: "Create new object types",
    label: "Object types",
    value: 2,
  },
  {
    name: "Create new statuses",
    label: "Statuses",
    value: 3,
  },
];

export const objectTypeSettings = [
  {
    label: "Create new",
    value: "createNew",
  },
  {
    label: "Do not restore",
    value: "doNotRestore",
  },
];

export const statusesSettings = [
  {
    label: "Create new",
    value: "createNew",
  },
  {
    label: "Do not restore",
    value: "doNotRestore",
  },
];

export const childObjectTypesSettings = [
  {
    label: "Create new",
    value: "createNew",
  },
  {
    label: "Do not restore",
    value: "doNotRestore",
  },
];

export const restoreObjectTypesSettingOptions = [
  {
    label: "Create new",
    value: "createNew",
  },
  {
    label: "Reuse existing",
    value: "associateExisting",
  },
];

export const restoreObjectsSettingOptions = [
  {
    label: "Create new",
    value: "createNew",
  },
  {
    label: "Do not restore",
    value: "doNotRestore",
  },
];

export const settingsText = {
  objectTypes: {
    title: "Object types",
    description: {
      createNew:
        "Revyz will create object types associated to the selected object schema.",
      doNotRestore:
        "Revyz will not create object types associated to the selected object schema.",
    },
  },
  statuses: {
    title: "Statuses",
    description: {
      createNew:
        "Revyz will create statuses associated to the selected object schema",
      doNotRestore:
        "Revyz will not create statuses associated to the selected object schema.",
    },
  },
  parentObjectTypes: {
    title: "Parent object types",
    description: {
      createNew:
        "Revyz will create parent object types of the selected object types to be restored.",
      associateExisting:
        "Revyz will reuse the parent object types of the selected object types to be restored.",
    },
  },
  statusesForObjectTypes: {
    title: "Statuses",
    description: {
      createNew:
        "Revyz will restore the statuses used in attributes of the selected object types.",
      associateExisting: "Revyz will reuse statuses if it exists.",
    },
  },
  childObjectTypes: {
    title: "Child object types",
    description: {
      createNew:
        "Revyz will create child object types of the selected object types.",
      doNotRestore:
        "Revyz will not create the child object types of the selected object types.",
    },
  },
  objects: {
    title: "Objects",
    description: {
      createNew: "Revyz will create objects of the selected object types.",
      doNotRestore:
        "Revyz will not create objects of the selected object types.",
    },
  },
};

export const whereToRestoreStatuses = [
  {
    label: "Original",
    value: 1,
    description:
      "Global statuses will be restored as Global status.\nSchema statuses will be mapped to its associated object schema.",
  },
  {
    label: "Global",
    value: 0,
    description: "Selected statuses will be restored as global statuses",
  },
];

export const onDemandBackupTypes = {
  Issues: 0,
  Configuration: 1,
  Assets_Configuration: 6,
  Assets_Objects: 7,
};

export const connectionStatusList = [
  { label: "Active", value: "ACTIVE" },
  { label: "Activation Pending", value: "ACTIVATION_PENDING" },
  { label: "Expired", value: "CONNECTION_EXPIRED" },
];

export const assetsObjectsFilter = [
  {
    label: "Let me select",
    value: "granular",
  },
  {
    label: "All objects",
    value: "allObjects",
  },
];

export const jobStatusForSnapshots = {
  1: "Snapshot status: Queued",
  2: "Snapshot status: Running",
  3: "Snapshot status: Success",
  4: "Snapshot status: Partial Success",
  5: "Snapshot status: Error",
  7: "Snapshot status: Not applicable",
};

export const issuesGranularFilter = [
  {
    label: "Granular",
    value: true,
  },
  {
    label: "All filterd issues",
    value: false,
  },
];

export const dontMapField = {
  id: 0,
  name: "Don't map this field",
};

export const CONFIG_OBJECTS_BACKUP_RDMJ = [
  "Automation rules",
  "Boards",
  "Fields",
  "Field contexts & options",
  "Field configurations",
  "Field configuration schemes",
  "Filters",
  "Issue types",
  "Issue link types",
  "Issue priorities",
  "Issue security schemes",
  "Issue type schemes",
  "Issue type screen schemes",
  "Notification schemes",
  "Projects",
  "Project categories",
  "Project components",
  "Project email",
  "Project features",
  "Project versions",
  "Screens",
  "Screen schemes",
  "Statuses",
  "Sprints",
  "Workflows",
  "Workflow schemes",
];

export const configObjectListForRCCMJ = [
  "Automation rules",
  "Boards",
  "Fields",
  "Field contexts & options",
  "Field configurations",
  "Field configuration schemes",
  "Filters",
  "Issue types",
  "Issue link types",
  "Issue priorities",
  "Issue security schemes",
  "Issue type schemes",
  "Issue type screen schemes",
  "Notification schemes",
  "Projects",
  "Project categories",
  "Project components",
  "Project email",
  "Project features",
  "Project versions",
  "Screens",
  "Screen schemes",
  "Statuses",
  "Workflows",
  "Workflow schemes",
];

export const issuesObjectList = [
  "Issues",
  "Attachments",
  "Comments",
  "Link",
  "Votes",
  "Worklogs",
];

export const assetsConfigObjectList = [
  "Object schemas",
  "Object types",
  "Object type Attributes",
  "Statuses",
];

export const assetObjectsList = [
  "Objects",
  "Object type References",
  <div>
    Object Comments <Lozenge appearance="new">BETA</Lozenge>
  </div>,
];

export const issueType = ["Issue types", "Issue type schemes"];
export const fields = [
  "Fields",
  "Field configurations",
  "Field configuration schemes",
  "Field context & options",
];

export const workflows = ["Workflows", "Workflow schemes"];

export const screens = [
  "Screens",
  "Screen schemes",
  "Issue type screen schemes",
];

export const issueFeatures = ["Issue linking"];
export const issueAttributes = [
  "Statuses",
  "Issue priorities",
  "Issue security schemes",
  "Notification schemes",
];

export const projects = [
  "Boards",
  "Filters",
  "Project categories",
  "Project versions",
  "Project components",
  "Project features",
  "Project email",
];

export const jccmDocumentationCardList = [
  {
    label: "Revyz Cloud Configuration Manager for Jira",
    desc: "Getting to know Revyz",
    linkUrl: "https://support.revyz.io/revyz-config-manager/",
    logo: RCCMJLogo,
    isLogo: true,
  },
  {
    label: "Release Notes",
    desc: "Documentation for our updates",
    linkUrl: "https://support.revyz.io/revyz-config-manager/release-notes",
    logo: ReleaseNotesLogo,
    isLogo: true,
  },
  {
    label: "FAQ",
    desc: "Frequently asked questions",
    linkUrl:
      "https://support.revyz.io/revyz-config-manager/frequently-asked-questions-faq-s",
    logo: FAQLogo,
    isLogo: true,
  },
  {
    label: "Get started",
    desc: "Instructions after installation",
    linkUrl: "https://support.revyz.io/revyz-config-manager/get-started",
    logo: GetStartedLogo,
    isLogo: true,
  },
  {
    label: "Legal and security",
    desc: "All things legal and security available here",
    linkUrl: "https://support.revyz.io/legal-security/",
    logo: LegalSecurityLogo,
    isLogo: true,
  },
  {
    label: "Licence",
    desc: "Revyz app licencing",
    linkUrl: "https://support.revyz.io/licensing/",
    logo: LicenseLogo,
    isLogo: true,
  },
];

export const ramjDocumentationCardList = [
  {
    label: "Revyz Assets Data Manager for Jira",
    desc: "Getting to know Revyz",
    linkUrl: "https://support.revyz.io/revyz-assets-data-manager/",
    logo: RADMJLogo,
    isLogo: true,
  },
  {
    label: "Release Notes",
    desc: "Documentation for our updates",
    linkUrl: "https://support.revyz.io/revyz-assets-data-manager/release-notes",
    logo: ReleaseNotesLogo,
    isLogo: true,
  },
  {
    label: "FAQ",
    desc: "Frequently asked questions",
    linkUrl:
      "https://support.revyz.io/revyz-assets-data-manager/frequently-asked-questions-faq-s",
    logo: FAQLogo,
    isLogo: true,
  },
  {
    label: "Get started",
    desc: "Instructions after installation",
    linkUrl:
      "https://support.revyz.io/revyz-assets-data-manager/copyget-started",
    logo: GetStartedLogo,
    isLogo: true,
  },
  {
    label: "Legal and security",
    desc: "All things legal and security available here",
    linkUrl: "https://support.revyz.io/legal-security/",
    logo: LegalSecurityLogo,
    isLogo: true,
  },
  {
    label: "Licence",
    desc: "Revyz app licencing",
    linkUrl: "https://support.revyz.io/licensing/",
    logo: LicenseLogo,
    isLogo: true,
  },
];

export const jdmDocumentationCardList = [
  {
    label: "Revyz Data Manager for Jira",
    desc: "Getting to know Revyz",
    linkUrl: "https://support.revyz.io/revyz-data-manager/",
    logo: RDMJLogo,
    isLogo: true,
  },
  {
    label: "Release Notes",
    desc: "Documentation for our updates",
    linkUrl: "https://support.revyz.io/revyz-data-manager/release-notes",
    logo: ReleaseNotesLogo,
    isLogo: true,
  },
  {
    label: "FAQ",
    desc: "Frequently asked questions",
    linkUrl:
      "https://support.revyz.io/revyz-data-manager/frequently-asked-questions-faq-s",
    logo: FAQLogo,
    isLogo: true,
  },
  {
    label: "Get started",
    desc: "Instructions after installation",
    linkUrl: "https://support.revyz.io/revyz-data-manager/get-started",
    logo: GetStartedLogo,
    isLogo: true,
  },
  {
    label: "Legal and security",
    desc: "All things legal and security available here",
    linkUrl: "https://support.revyz.io/legal-security/",
    logo: LegalSecurityLogo,
    isLogo: true,
  },
  {
    label: "Licence",
    desc: "Revyz app licencing",
    linkUrl: "https://support.revyz.io/licensing/",
    logo: LicenseLogo,
    isLogo: true,
  },
];

export const prodAppType = {
  JDM: 0,
  JCCM: 1,
  RAMJ: 2,
};

export const OBJECT_TYPES = [
  "boards",
  "filters",
  "fields",
  // "fieldContexts",
  // "fieldContextOptions",
  "fieldConfigurations",
  "fieldConfigurationSchemes",
  // "issueLinkTypes",
  // "issuePriorities",
  "issueTypes",
  "issueTypeSchemes",
  "issueTypeScreenSchemes",
  // "issueTypeSecurityScheme",
  // "notificationSchemes",
  // "permissionSchemes",
  // "projectCategories",
  // "projectComponents",
  // "projectEmails",
  // "projectFeatures",
  // "projectRoles",
  // "projectRoleActors",
  // "projectVersions",
  "screens",
  "screenSchemes",
  // "sprints",
  "statuses",
  "workflows",
  "workflowSchemes",
];

export const ACTION_TO_BE_TAKEN = {
  1: "NO_ACTION",
  2: "CREATE",
  3: "MODIFY",
  4: "CREATE_WORKFLOW",
  5: "CREATION_NOT_SUPPORTED",
  6: "MODIFICATION_NOT_SUPPORTED",
  7: "DELETION_NOT_SUPPORTED",
  undefined: "NA",
};

export const JIRA_OBJECT_ACTION = {
  1: "NO_ACTION",
  2: "CREATE",
  3: "MODIFY",
  4: "CREATE_WORKFLOW",
  5: "CREATE_NOT_SUPPORTED",
  6: "MODIFY_NOT_SUPPORTED",
  7: "DELETION_NOT_SUPPORTED",
  undefined: "NA",
};

export const actionTypeValue = {
  NO_ACTION: 1,
  CREATE: 2,
  UPDATE: 3,
  CREATE_WORKFLOW: 4,
  CREATION_NOT_SUPPORTED: 5,
  UPDATION_NOT_SUPPORTED: 6,
  DELETION_NOT_SUPPORTED: 7,
};

export const JIRA_OBJECT_STATUS = {
  1: "CREATED",
  2: "MODIFIED",
  3: "NO_CHANGE",
  4: "NOT_PRESENT_ON_SOURCE",
  5: "NOT_PRESENT_ON_DESTINATION",
  6: "DELETED",
  undefined: "NA",
};

export const JIRA_OBJECT_STATUS_STRING = {
  CREATED: 1,
  MODIFIED: 2,
  NO_CHANGE: 3,
  NOT_PRESENT_ON_SOURCE: 4,
  NOT_PRESENT_ON_DESTINATION: 5,
  DELETED: 6,
  undefined: "NA",
};

export const OBJECT_STATUS_TOOL_TIP_CONTENT = {
  CREATED: "",
  DELETED: "",
  NO_CHANGE: "",
  MODIFIED: "",
  NOT_PRESENT_ON_SOURCE: "",
  NOT_PRESENT_ON_DESTINATION: "",
  NA: "",
};

export const snapshotTypes = {
  Issues: 1,
  Configuration: 2,
};

export const PRESENT_IN_SOURCE_DESTINATION = {
  0: "NOT_PRESENT",
  1: "PRESENT",
  undefined: "NA",
};

export const PRESENT_IN_SOURCE_DESTINATION_TOOL_TIP_CONTENT = {
  PRESENT: "",
  NOT_PRESENT: "",
  NA: "",
};

export const PROJECT_TYPES = {
  ALL: 0,
  CLASSIC: 1,
  NEXT_GEN: 2,
};

export const OBJECT_ACTION_TOOL_TIP_CONTENT = {
  NO_ACTION: "",
  CREATE: "",
  CREATE_WORKFLOW: "",
  MODIFY: "",
  DELETION_NOT_SUPPORTED: "",
  CREATE_NOT_SUPPORTED: "",
  MODIFY_NOT_SUPPORTED: "",
  NA: "",
};

export const cloneConfigObjectStatusFiltersSameSite = [
  {
    label: "Created",
    value: 1,
  },
  {
    label: "Modified",
    value: 2,
  },
  {
    label: "No change",
    value: 3,
  },
  // {
  //   label: "Object not present on source",
  //   value: 4,
  // },
  {
    label: "Deleted",
    value: 6,
  },
];

export const cloneConfigObjectStatusFiltersCrossSite = [
  // {
  //   label: "Objects created",
  //   value: 1,
  // },
  {
    label: "Modified",
    value: 2,
  },
  {
    label: "No change",
    value: 3,
  },
  {
    label: "Not present on source",
    value: 4,
  },
  {
    label: "Not present on destination",
    value: 5,
  },
];

export const CLONE_CONFIG_OBJECT_ACTION_FILTER_OPTIONS = [
  {
    label: "Create",
    value: 2,
  },
  {
    label: "Modify",
    value: 3,
  },
  {
    label: "Create",
    value: 4,
  },
];

export const CLONE_CONFIG_OBJECT_ACTION_FILTER_OPTIONS_WITH_BULK_WORKFLOW = [
  {
    label: "Create",
    value: 2,
  },
  {
    label: "Modify",
    value: 3,
  },
];

export const brandColor = "#253858";
export const textColor = "#F4F5F7";

export const PROJECT_KEY_ERROR_MESSAGES = {
  START_CHAR: "Project keys must start with an uppercase letter",
  INVALID_CHAR:
    "Project keys must start with an uppercase letter, followed by one or more uppercase alphanumeric characters",
  SHORT_KEY:
    "Project keys must have two or more uppercase alphanumeric characters.",
  KEY_IN_USE: "A Project uses this project key",
  LONG_KEY: "The project key must not exceed 10 characters in length",
};

export const PROJECT_NAME_ERROR_MESSAGES = {
  INVALID_CHARS: "Name should have valid caharcters",
  SHORT_NAME: "The project name is too short",
  NAME_IN_USE: "A project with that name already exists",
  LONG_NAME: "The project name is too long",
};

export const accordionTypeForOnDemandBackup = {
  jiraIssues: 1,
  jiraConfigurations: 2,
  assetsObjects: 3,
  assetsConfigurations: 4,
};

export const tncCheckBoxListForRAMJ = [
  {
    key: 1,
    label: "Run assets backup immediately",
    isRequired: false,
  },
  {
    key: 2,
    label: "I agree to all the settings",
    isRequired: true,
  },
];

export const tncCheckBoxListForRCCMJ = [
  {
    key: 1,
    label: "Run Jira configuration backup immediately",
    isRequired: false,
  },
  {
    key: 2,
    label: "I agree to all the settings",
    isRequired: true,
  },
];

export const AUTOMATION_RULES_SCOPE_OPTIONS = [
  {
    label: "Global",
    value: 1,
  },
  {
    label: "Single project",
    value: 2,
  },
  {
    label: "Multi project",
    value: 3,
  },
  {
    label: "Project type",
    value: 4,
  },
];

export const AUTOMATION_RULES_SCOPES = {
  GLOBAL: 1,
  SINGLE_PROJECT: 2,
  MULTI_PROJECT: 3,
  PROJECT_TYPE: 4,
};

export const AUTOMATION_RULES_SCOPE_STRING = {
  1: "Global",
  2: "Single project",
  3: "Multi project",
  4: "Project type",
};

export const AUTOMATION_RULES_WRITE_ACCESS_TYPE_OPTIONS = [
  {
    label: "Private",
    value: 1,
  },
  {
    label: "All admins",
    value: 2,
  },
  {
    label: "Specified admins",
    value: 3,
  },
];

export const AUTOMATION_RULES_WRITE_ACCESS_TYPES = {
  OWNER_ONLY: 1,
  UNRESTRICTED: 2,
  SPECIFIED_USERS: 3,
};

export const AUTOMATION_RULES_WRITE_ACCESS_STRING = {
  1: "Private",
  2: "All admins",
  3: "Specified admins",
};
export const OBJECT_SCHEMA_KEY_ERROR_MESSAGES = {
  INVALID_CHAR:
    "Key must contain only alphabetic letters and digits and be 2-10 characters long.",
  SHORT_KEY:
    "Key must contain only alphabetic letters and digits and be 2-10 characters long.",
  LONG_KEY:
    "Key must contain only alphabetic letters and digits and be 2-10 characters long.",
  KEY_IN_USE: "This key is already in use.",
  REQUIRED: "Key is required",
};

export const OBJECT_SCHEMA_NAME_ERROR_MESSAGES = {
  INVALID_CHARS: "Please enter unique object schema name",
  SHORT_NAME: "Name must contain at least 2 and max 50 characters",
  NAME_IN_USE: "Name has to be unique!",
  LONG_NAME: "The object schema name is too long",
  REQUIRED: "Schema name is required",
  // below cases are for renaming existing schema
  LONG_NAME_MODIFY: "Name must contain less than 30 characters",
  SHORT_NAME_MODIFY: "Name must contain at least 2 characters",
};

export const FILTER_VARIANTS = {
  TEXT: "text",
  AUTO_COMPLETE: "autocomplete",
  SINGLE_SELECT: "select",
  MULTI_SELECT: "multi-select",
  RANGE: "range",
  RANGE_SLIDER: "range-slider",
  DATE: "date",
  DATE_RANGE: "date-range",
  CHECKBOX: "checkbox",
};

export const FILE_SIZE_OPTIONS = [
  {
    label: "0 B - 500 KB",
    value: 1,
  },
  {
    label: "500 KB - 5 MB",
    value: 2,
  },
  {
    label: "5 MB - 25 MB",
    value: 3,
  },
  {
    label: "25 MB - 50 MB",
    value: 4,
  },
  {
    label: "50 MB - 250 MB",
    value: 5,
  },
  {
    label: "250 MB - 1 GB",
    value: 6,
  },
  {
    label: "1 GB - 2 GB",
    value: 7,
  },
];

export const FILE_SIZE_RANGE_TO_VALUE = {
  1: { min: 0, max: 512000 },
  2: { min: 512000, max: 5242880 },
  3: { min: 5242880, max: 26214400 },
  4: { min: 26214400, max: 52428800 },
  5: { min: 52428800, max: 262144000 },
  6: { min: 262144000, max: 1073741824 },
  7: { min: 1073741824, max: 2147483648 },
};

export const SITE_NAME_ERROR_MESSAGES = {
  EMPTY: "Please enter jira cloud site url.",
  ASSETS_NOT_FOUND: "No assets found in the mentioned site.",
  INVALID:
    "Your site name must be 3 or more lowercase letters and/or numbers. Hyphens are ok if they’re in the middle.",
  SAME_SITE:
    "Same site Url is not allowed, if you want to restore on same site then go back and select same site.",
};

export const PAGINATION_TYPE = {
  1: "5", // ASSET_OBJECT_SCHEMA
  2: "6", // ASSET_OBJECT_TYPE
  3: "7", // ASSET_STATUS
};
export const APP_NAMES = {
  0: "Revyz Data Manager for Jira",
  1: "Revyz Cloud Configuration Manager for Jira",
  2: "Revyz Assets Data Manager for Jira",
};

export const BACKUP_SCHEDULER_TIME_RANGE = [
  {
    label: "00:00 UTC - 02:00 UTC",
    value: 1,
  },
  {
    label: "02:00 UTC - 04:00 UTC",
    value: 3,
  },
  {
    label: "04:00 UTC - 06:00 UTC",
    value: 5,
  },
  {
    label: "06:00 UTC - 08:00 UTC",
    value: 7,
  },
  {
    label: "08:00 UTC - 10:00 UTC",
    value: 9,
  },
  {
    label: "10:00 UTC - 12:00 UTC",
    value: 11,
  },
  {
    label: "12:00 UTC - 14:00 UTC",
    value: 13,
  },
  {
    label: "14:00 UTC - 16:00 UTC",
    value: 15,
  },
  {
    label: "16:00 UTC - 18:00 UTC",
    value: 17,
  },
  {
    label: "18:00 UTC - 20:00 UTC",
    value: 19,
  },
  {
    label: "20:00 UTC - 22:00 UTC",
    value: 21,
  },
  {
    label: "22:00 UTC - 00:00 UTC",
    value: 23,
  },
];

export const BACKUP_SCHEDULER_TIME_RANGE_TO_STRING = {
  1: "00:00 UTC - 02:00 UTC",
  3: "02:00 UTC - 04:00 UTC",
  5: "04:00 UTC - 06:00 UTC",
  7: "06:00 UTC - 08:00 UTC",
  9: "08:00 UTC - 10:00 UTC",
  11: "10:00 UTC - 12:00 UTC",
  13: "12:00 UTC - 14:00 UTC",
  15: "14:00 UTC - 16:00 UTC",
  17: "16:00 UTC - 18:00 UTC",
  19: "18:00 UTC - 20:00 UTC",
  21: "20:00 UTC - 22:00 UTC",
  23: "22:00 UTC - 00:00 UTC",
};

export const BACKUP_SCHEDULER_TIME_RANGE_TO_INTEGER = {
  "00:00 UTC - 02:00 UTC": 1,
  "02:00 UTC - 04:00 UTC": 3,
  "04:00 UTC - 06:00 UTC": 5,
  "06:00 UTC - 08:00 UTC": 7,
  "08:00 UTC - 10:00 UTC": 9,
  "10:00 UTC - 12:00 UTC": 11,
  "12:00 UTC - 14:00 UTC": 13,
  "14:00 UTC - 16:00 UTC": 15,
  "16:00 UTC - 18:00 UTC": 17,
  "18:00 UTC - 20:00 UTC": 19,
  "20:00 UTC - 22:00 UTC": 21,
  "22:00 UTC - 00:00 UTC": 23,
};

export const FILTERS_ON_COLUMN = ["client_key", "tenant_id"];
